import useRequest from '@/websdk/utils/request';
export default (function () {
  const { isRequestSuccessed, exec } = useRequest({
    url: '/api/ipqc/inspection/main',
    name: 'IPQC_PROCESS_INSPECTION_POST',
    method: 'POST',
  });
  return [isRequestSuccessed, exec];
});
